import styled from "styled-components";

import { FlexDiv } from "@/components/Atoms/Box";
import StyledSvgSprite from "@/components/Atoms/SVGSprite";

import Typography from "@/foundation/Typography/V2";

export const BrandLogo = styled(StyledSvgSprite)``;
export const Heading = styled(Typography)``;
export const ImageBox = styled(FlexDiv)``;
export const LHSDiv = styled(FlexDiv)`
  align-items: center;
  margin-right: 24px;
  flex: 1;
  ${Heading} {
    color: ${({ isDark, theme }) =>
      isDark ? theme.colors.white : theme.colorsV2.primary.shade_800};
    @media only screen and (max-width: 420px) {
      font-size: 14px;
    }
  }
  ${ImageBox} {
    user-select: none;
    pointer-events: none;
    margin-right: 24px;
    background-color: ${({ isDark, theme }) =>
      isDark ? theme.colors.white : theme.colorsV2.shyft.purple_text};
    height: 40px;
    width: 40px;
    min-width: 40px;
    min-height: 40px;
    border-radius: 12px;
    overflow: hidden;
    align-items: center;
    justify-content: center;
    ${BrandLogo} {
      fill: ${({ isDark, theme }) =>
        isDark ? theme.colors.brand_logo : theme.colors.white};
    }
    @media only screen and (max-width: 767px) {
      margin-right: 8px;
    }
    @media only screen and (max-width: 420px) {
      display: none;
    }
  }
  @media only screen and (max-width: 767px) {
    max-width: 80%;
    margin-right: 16px;
  }
`;
